import { Trans } from '@lingui/react/macro';

import { Button } from '@/components/buttons';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/Dialog';

type Props = {
  open: boolean;
  onCancel: () => void;
  onDelete: () => void;
};

const ChannelMappingRuleDeleteDialog = ({ open, onCancel, onDelete }: Props) => {
  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onCancel()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            <Trans>Delete Rule</Trans>
          </DialogTitle>
        </DialogHeader>
        <div>
          <Trans>Are you sure you want to delete this rule?</Trans>
        </div>
        <DialogFooter>
          <DialogClose
            render={
              <Button size="large">
                <Trans>Cancel</Trans>
              </Button>
            }
          />
          <Button size="large" variant="primary" danger onClick={onDelete}>
            <Trans>Yes, Delete</Trans>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ChannelMappingRuleDeleteDialog;
